import getDateFromYYYYMMDDString from '@stencil/flights-date-utils/src/get-date-from-yyyymmdd-string';
import dateDiff from '@stencil/flights-date-utils/src/date-diff';
import getDTTime from '@stencil/flights-date-utils/src/get-dt-time';
import dateformat from 'dateformat';

export const getFlightDetails = ({
  flight,
  refundabilityArr,
  airportsArr,
  carriersArr,
  datesArr,
  valueArr,
  iconArr = [],
  discountFares,
  discountMessages,
  originalIndex,
  showOnePaxPrice
}) => {
  // console.log('getFlightDetails :', flight);
  const priceToShow = showOnePaxPrice ? 'p1' : 'p';

  const duration = getDurationForDisplay(flight.t);
  const pricePerPerson = getPriceString(flight.p1);
  const pricePerPersonNonFormatted = flight.p1;
  const price = getPriceString(flight.p);
  const priceToDisplay = showOnePaxPrice ? pricePerPerson : price;
  const slashedFare = flight.sa;
  const refundability = refundabilityArr[flight.w];
  const tt = flight.tt ? flight.tt : undefined;
  const fareKey = flight?.fk || '';
  let handBaggageOnly = null;
  let benefitTagData = [];
  if (flight?.hb) {
    const handBaggageNode = flight?.hb;
    handBaggageOnly = {};
    handBaggageOnly['text'] = valueArr?.[handBaggageNode?.t];
    handBaggageOnly['bgColor'] = handBaggageNode?.bg?.map(bgIndex => valueArr[bgIndex]);
  }
  if (flight?.bt) {
    // benefit Tag
    flight?.bt?.map(benefit => {
      const obj = {
        text: valueArr[benefit?.tx],
        icon: iconArr?.[benefit?.tic],
        bgColor: benefit?.bgc?.map(bgIndex => valueArr[bgIndex]),
        tColor: benefit?.tc?.map(tcIndex => valueArr[tcIndex])
      };
      benefitTagData.push(obj);
    });
  }

  const flightsTags = flight?.tl?.map(benefit => {
    const obj = {
      text: valueArr?.[benefit?.tx],
      icon: iconArr?.[benefit?.tic],
      bgColor: benefit?.bgc?.map(bgIndex => valueArr[bgIndex]),
      tColor: benefit?.tc?.map(tcIndex => valueArr[tcIndex])
    };
    return obj;
  });

  // const offerInfo = {
  //   showOffer: !!flight.so,
  //   offerText: flight.so ? valueArr[flight.so.ot] : '',
  //   offerStyle: { color: flight.so ? valueArr[flight.so.tc] : '' }
  // };

  let freeMeal = true;
  let mealText = '';
  let handBaggageText = flight.ib ? valueArr[flight.ib] : null;
  const carrierLogoArr = [];
  const carrierNameArr = [];
  const valuesForSort: {
    recommended: string;
    cost: number;
    duration: number;
    departure?: number;
    carrier?: any;
    multiCheckin?: any;
    isCodeShareFlight?: boolean;
  } = {
    recommended: flight.bs,
    cost: flight[5] || flight[priceToShow],
    duration: flight.t,
    multiCheckin: flight && flight.hasOwnProperty('mp')
  };
  const priceBreakup = { base: null, tax: null, total: null };
  priceBreakup.base = flight?.b;
  priceBreakup.tax = flight?.x;
  priceBreakup.total = flight?.p1 || flight?.p;

  // if (flight.pf && flight.pf.length >= 0) {
  //   priceBreakup.base = flight?.pf[0]?.tb?.a?.b;
  //   priceBreakup.tax = flight?.pf[0]?.tb?.a?.tx;
  //   priceBreakup.total = flight?.pf[0]?.tb?.a?.tf;
  // } else {
  //   priceBreakup.base = flight?.b;
  //   priceBreakup.tax = flight?.x;
  //   priceBreakup.total = flight?.p1 || flight?.p;
  // }

  Object.keys(priceBreakup).forEach(key => {
    if (priceBreakup[key]) {
      priceBreakup[key] = getPriceString(priceBreakup[key]);
    }
  });

  const flightArr = flight.f.map((flightItem, index) => {
    if (
      !valuesForSort['isCodeShareFlight'] &&
      flightItem.oc > -1 &&
      flightItem.oc !== flightItem.c
    ) {
      valuesForSort['isCodeShareFlight'] = true;
    }

    if (index === 0) {
      valuesForSort['departure'] = flightItem.d;
      valuesForSort['carrier'] = flightItem.c;
    }
    if (index > 0) {
      if (valuesForSort['carrier'] !== flightItem.c) {
        valuesForSort['carrier'] = 'multi';
      }
    }
    if (flightItem.hasOwnProperty('mt') && flightItem.mt !== 0 && valueArr?.length) {
      mealText = valueArr[flightItem.mt];
    }
    if (flightItem.fm === 1) {
      freeMeal = freeMeal && true;
    } else {
      freeMeal = false;
    }
    const depDate = getCardDateObject(
      getDateFromYYYYMMDDString(datesArr[flightItem[1]].toString())
    );
    const arrDate = getCardDateObject(
      getDateFromYYYYMMDDString(datesArr[flightItem[2]].toString())
    );

    if (index === flight.f.length - 1) {
      const depDateObj = getDateFromYYYYMMDDString(datesArr[flight.f[0][1]].toString());
      const dayDiff = dateDiff(depDateObj, arrDate.dateObj);
      valuesForSort['arrival'] = dayDiff * 10000 + flightItem.a;
    }

    const duration = getDurationForDisplay(flightItem.t);
    const depTime = getDisplayTime(flightItem.d);
    const arrTime = getDisplayTime(flightItem.a);
    const visaRequired = flightItem.vr;
    const depCode = airportsArr[flightItem.u].i;
    const arrCode = airportsArr[flightItem.g].i;
    const depText = airportsArr[flightItem.u].t;
    const arrText = airportsArr[flightItem.g].t;
    const depCountry = airportsArr[flightItem.u].c;
    const arrCountry = airportsArr[flightItem.g].c;
    const carrier = {
      carrierIndex: flightItem.c,
      carrierCode: carriersArr[flightItem.c].c,
      carrierName: carriersArr[flightItem.c].n,
      ...(flightItem.oc > -1 && flightItem.oc !== flightItem.c
        ? { operatingCarrierName: carriersArr[flightItem.oc].n }
        : null)
    };
    const flightNumber = `${carriersArr[flightItem.c].c}${flightItem.n}` || '';
    if (carrierLogoArr.indexOf(carrier.carrierCode) === -1) {
      carrierLogoArr.push(carrier.carrierCode);
      carrierNameArr.push(carrier.carrierName);
    }
    const layoverInfo = flightItem.l ? getDurationForDisplay(flightItem.l) : undefined;
    let nearByDestination;
    let nearBySource;
    if (flightItem.ndi) {
      nearByDestination = {
        bgc: flightItem.ndi.bgc.map(itm => valueArr[itm]),
        nbi: iconArr?.[flightItem.ndi.nbi],
        nbt: valueArr[flightItem.ndi.nbt]
      };
    }
    if (flightItem.nsi) {
      nearBySource = {
        bgc: flightItem.nsi.bgc.map(itm => valueArr[itm]),
        nbi: iconArr?.[flightItem.nsi.nbi],
        nbt: valueArr[flightItem.nsi.nbt]
      };
    }

    return {
      duration,
      depDate,
      arrDate,
      depTime,
      arrTime,
      depCode,
      arrCode,
      depText,
      arrText,
      depCountry,
      arrCountry,
      carrier,
      flightNumber,
      ...(layoverInfo ? { layoverInfo } : null),
      ...(visaRequired ? { visaRequired } : null),
      ...(nearByDestination && { nearByDestination }),
      ...(nearBySource && { nearBySource })
    };
  });
  const arrivalDetails = getArrival(flightArr);
  const footerText = getFooterText(refundability, tt, freeMeal, handBaggageText, mealText);
  let discountedFare = undefined;
  let disMessage = undefined;
  let discount = undefined;
  if (flight[5] && flight[7] && flight[8]) {
    disMessage = discountMessages[flight[8]];
    discountedFare = getPriceString(flight[5]);
    discount = getPriceString(discountFares[flight[7]]);
  }
  // let showOffer = false;
  // let offerText = '';
  // let offerStyle = { color: '' };
  // if (flight.so) {
  //   showOffer = false;
  //   offerText = valueArr[flight.so.ot];
  //   offerStyle = { color: valueArr[flight.so.tc] };
  // }
  let discountApply = flight.da;
  const multiCheckingText = flight.mp ? valueArr[flight.mp] : '';

  const modeOfTransportPopup = flight?.mtp || null;

  return {
    duration,
    pricePerPerson,
    price,
    priceToDisplay,
    slashedFare,
    priceBreakup,
    refundability,
    flightArr,
    discountApply,
    arrivalDetails,
    originalIndex,
    valuesForSort,
    footerText,
    carrierLogoArr,
    carrierNameArr,
    // offerDetails: {
    //   showOffer,
    //   offerText,
    //   offerStyle
    // },
    id: flight.id,
    // ...(offerInfo.showOffer ? { offerInfo } : null),
    ...(tt ? { tt } : null),
    ...(disMessage ? { disMessage } : null),
    ...(discountedFare ? { discountedFare } : null),
    ...(discount ? { discount } : null),
    ...(freeMeal ? { freeMeal } : null),
    ...(handBaggageText ? { handBaggageText } : null),
    ...(flight.alternateTime ? { alternateTime: true } : null),
    ...(flight.alternateLocation ? { alternateLocation: true } : null),
    ...(flight.fs ? { alternateSavings: flight.fs } : null),
    ...(flight.nd ? { alternateNearbyDistance: flight.nd } : null),
    ...(fareKey ? { fareKey } : null),
    pricePerPersonNonFormatted,
    multiCheckingText,
    ...(handBaggageOnly ? { handBaggageOnly } : null),
    ...(benefitTagData ? { benefitTagData } : null),
    modeOfTransportPopup,
    ...(flightsTags ? { flightsTags } : null)
  };
};

export function getDurationForDisplay(dur) {
  return (dur / 100).toFixed(2).replace('.', 'h ') + 'm';
}

export function getPriceString(price) {
  return price
    .toLocaleString('en-IN', {
      maximumFractionDigits: 2,
      style: 'currency',
      currency: 'INR'
    })
    .replace('.00', '')
    .replace('₹', '')
    .trim();
}

function getCardDateObject(dateObj) {
  if (!dateObj) {
    return null;
  }
  return {
    dateObj: dateObj.toString(),
    day: dateformat(dateObj, 'dddd'),
    date: dateformat(dateObj, 'dd'),
    dateOnCard: dateformat(dateObj, 'ddd, dd mmm')
  };
}

function getDisplayTime(time) {
  const displayTime = ('0' + (time / 100).toFixed(2)).replace('.', ':');
  return displayTime.substring(displayTime.length - 5);
}

const getArrival = flights => {
  let finalIndex = flights.length === 1 ? 0 : flights.length - 1;
  const finalArr = flights[finalIndex];
  const dayDiff = dateDiff(flights[0].depDate.dateObj, finalArr.arrDate.dateObj);
  return {
    arrCode: finalArr.arrCode,
    arrText: finalArr.arrText,
    arrCountry: finalArr.arrCountry,
    // arrTime: `${finalArr.arrTime}${arrDate > depDate ? `+${arrDate - depDate}D` : ''}`,
    arrTime: finalArr.arrTime,
    arrDayDiff: dayDiff
  };
};

const getFooterText = (refundability, tt, freeMeal, handBaggage, mealText = '') => {
  // const refundabilityText = refundability === 'Refundable' ? refundability : '';
  // const refundabilityText = refundability || '';
  const timeToConfirmText = tt ? 'Get your ticket confirmation within ' + getDTTime(tt) : '';
  const freeMealText = mealText ? mealText : freeMeal ? 'Free Meal' : '';
  const handBaggageText = handBaggage ? handBaggage : '';
  return [timeToConfirmText, freeMealText, handBaggageText].filter(text => text !== '').join(' - ');
};

export function sortMseByPrice(a, b) {
  return a.p - b.p;
}

export const getMessageList = (text, textArr, value, valueArr, icon, iconArr) => {
  if (text && value && textArr && valueArr) {
    if (icon && iconArr) {
      return text.map((key, index) => {
        const a = {
          icon: iconArr[icon[index]],
          text: textArr[key],
          value: valueArr[value[index]]
        };
        return a;
        // return textArr[key].replace('%s', valueArr[ancillary.v[index]]);
      });
    } else {
      return text.map((key, index) => {
        const a = {
          text: textArr[key].replace('%s', valueArr[value[index]])
        };
        return a;
        // return textArr[key].replace('%s', valueArr[ancillary.v[index]]);
      });
    }
  }
  return [];
};

export const getTotalMinutesFromDuration = dur => {
  try {
    let totalMin = '';
    if (dur) {
      const [h, m] = dur.replace('m', '').split('h ');
      return parseInt(h) * 60 + parseInt(m);
    }
    return totalMin;
  } catch (ex) {
    return '';
  }
};

export const getCouponPersuationDetails = ({ rKeys = {}, messageValues = [], id = '' }) => {
  const offerInfo = {
    offerText: '',
    offerColor: ''
  };
  const couponPersuasion = rKeys?.[id]?.cp || null;
  if (couponPersuasion) {
    const { text = '', color = '' } = couponPersuasion;
    const cpText = messageValues?.[text] || '';
    if (cpText) {
      offerInfo['offerText'] = cpText;
      offerInfo['offerColor'] = color;
    }
  }
  return offerInfo;
};
